/* 90'S HOME v2 — trang sản phẩm: ảnh, biến thể, giỏ hàng, Mua ngay, thanh ghim, tab, video, chi tiết, hỏi đáp, liên quan. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesk = window.matchMedia('(min-width: 990px)');
  var behavior = reduce ? 'auto' : 'smooth';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) { return Math.round(cents / 100).toLocaleString('vi-VN') + '₫'; }

  function headerBottom() {
    var h = $('.section-header');
    if (!h) return 0;
    /* Menu đang ẩn (trượt xuống) hoặc sắp ẩn → coi như 0 */
    if (h.classList.contains('shopify-section-header-hidden')) return 0;
    /* Menu đang hiện lại (đang trượt xuống) → lấy chiều cao menu, không đo vị trí lúc đang chạy hiệu ứng */
    if (h.classList.contains('shopify-section-header-sticky') && h.classList.contains('scrolled-past-header')) return h.offsetHeight;
    var b = h.getBoundingClientRect().bottom;
    return b > 0 ? b : 0;
  }
  /* Menu tự ẩn khi cuộn xuống (trang sản phẩm) → cuộn xuống tới mục thì không chừa chỗ cho menu */
  function headerAutoHides() {
    var s = $('sticky-header');
    return !!s && s.getAttribute('data-sticky-type') === 'on-scroll-up';
  }
  function scrollToEl(el, extra) {
    if (!el) return;
    var tabs = $('[data-v2-tabs]');
    var tabH = tabs && !tabs.classList.contains('is-hidden') ? tabs.offsetHeight : 0;
    var off = headerBottom() + tabH + (extra || 8);
    if (headerAutoHides() && el.getBoundingClientRect().top - off > 0) off = tabH + (extra || 8);
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - off, behavior: behavior });
  }

  /* ---------------- Khối mua ---------------- */
  function initBuy(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var variants = JSON.parse($('[data-v2-variants]', root).textContent);
    var mediaIds = JSON.parse($('[data-v2-media]', root).textContent);
    var form = $('[data-v2-form]', root);
    var idInput = $('[data-variant-id]', form);
    var qtyInput = $('[data-qty-input]', form);
    var errEl = $('[data-err]', form);
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];

    /* ---------- Bảng chọn sản phẩm (kiểu Shopee) ---------- */
    var pick = $('[data-v2-pick]', root);
    var toast = $('[data-v2-toast]', root);
    if (pick) document.body.appendChild(pick); /* ra ngoài để không bị khung cha che/cắt */
    if (toast) document.body.appendChild(toast);
    var cfgEl = document.getElementById('V2Cart');
    var CFG = cfgEl ? {
      free: +cfgEl.dataset.free || 0, ship: +cfgEl.dataset.ship || 0,
      t1: +cfgEl.dataset.tier1Qty || 0, o1: +cfgEl.dataset.tier1Off || 0,
      t2: +cfgEl.dataset.tier2Qty || 0, o2: +cfgEl.dataset.tier2Off || 0
    } : null;
    var cartNow = { item_count: 0, original_total_price: 0 };
    var pickOpen = false, lastFocus = null;
    function loadCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartNow = c; recalc(); })
        .catch(function () {});
    }
    /* Giảm giá + phí ship ước tính ngay khi đổi loại/số lượng (gộp cả các món đã có trong giỏ, giống lúc Mua ngay) */
    function recalc() {
      if (!pick) return;
      var q = qty(), price = current.price;
      var n = (cartNow.item_count || 0) + q;
      var sub = (cartNow.original_total_price || 0) + price * q;
      var pct = 0;
      if (CFG && CFG.t2 && n >= CFG.t2) pct = CFG.o2;
      else if (CFG && CFG.t1 && n >= CFG.t1) pct = CFG.o1;
      var disc = Math.round(sub * pct / 100);
      var after = sub - disc;
      var ship = CFG && CFG.free && after < CFG.free * 100 ? CFG.ship * 100 : 0;
      var dl = $('[data-pk-disc-l]', pick), dv = $('[data-pk-disc]', pick);
      if (pct) { dl.textContent = 'Giảm ' + pct + '% (' + n + ' sản phẩm)'; dv.textContent = '−' + money(disc); dv.className = 'is-ok'; }
      else if (CFG && CFG.t1) { dl.textContent = 'Giảm giá'; dv.textContent = 'Mua ' + CFG.t1 + ' giảm ' + CFG.o1 + '%'; dv.className = 'is-hint'; }
      else { dl.textContent = 'Giảm giá'; dv.textContent = '0₫'; dv.className = ''; }
      var sv = $('[data-pk-ship]', pick);
      if (!CFG || !CFG.free) { sv.textContent = 'Tính ở bước thanh toán'; sv.className = ''; }
      else if (ship) { sv.innerHTML = money(ship) + ' <small>· thêm ' + money(CFG.free * 100 - after) + ' freeship</small>'; sv.className = ''; }
      else { sv.textContent = 'Miễn phí'; sv.className = 'is-ok'; }
      var inc = $('[data-pk-incart]', pick);
      inc.textContent = cartNow.item_count ? 'Đã tính cả ' + cartNow.item_count + ' sản phẩm đang có trong giỏ' : '';
      $('[data-pk-total]', pick).textContent = current.available ? money(after + ship) : '';
    }
    if (pick) loadCart(); /* tải sẵn giỏ: mở bảng là số đã đúng, không nhảy */
    function lockScroll(on) { document.documentElement.classList.toggle('v2-lock', on); }
    function openPick() {
      if (!pick || pickOpen) return;
      pickOpen = true;
      lastFocus = document.activeElement;
      pick.hidden = false;
      void pick.offsetWidth; /* ép trình duyệt vẽ trạng thái đóng trước để có hiệu ứng trượt lên */
      pick.classList.add('is-open');
      lockScroll(true);
      try { history.pushState({ v2pick: 1 }, ''); } catch (e) {}
      recalc();
      loadCart();
      var box = $('.v2-pick__box', pick);
      setTimeout(function () { box.focus({ preventScroll: true }); }, 50);
    }
    function closePick(fromPop) {
      if (!pickOpen) return;
      pickOpen = false;
      pick.classList.remove('is-open');
      lockScroll(false);
      setTimeout(function () { if (!pickOpen) pick.hidden = true; }, 320);
      if (!fromPop) { try { if (history.state && history.state.v2pick) history.back(); } catch (e) {} }
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    var toastT = 0;
    function showToast() {
      if (!toast) return;
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add('is-on');
      clearTimeout(toastT);
      toastT = setTimeout(function () { toast.classList.remove('is-on'); setTimeout(function () { toast.hidden = true; }, 300); }, 3500);
    }
    if (pick) {
      pick.addEventListener('click', function (e) { if (e.target.closest('[data-pick-close]')) closePick(false); });
      document.addEventListener('keydown', function (e) { if (pickOpen && e.key === 'Escape') closePick(false); });
      window.addEventListener('popstate', function () { if (pickOpen) closePick(true); });
    }
    if (toast) toast.addEventListener('click', function (e) { if (e.target.closest('[data-open-cart]')) { toast.classList.remove('is-on'); toast.hidden = true; } });

    /* Khối ưu đãi mua nhiều trên trang (lấy đúng mức trong cài đặt giỏ hàng) */
    var tiersEl = $('[data-v2-tiers]', root);
    if (tiersEl && CFG && CFG.t1) {
      function card(qtyTxt, offTxt, best) {
        return '<div class="v2-tier' + (best ? ' is-best' : '') + '">' + (best ? '<i>Lợi nhất</i>' : '') + '<b>' + offTxt + '</b><span>' + qtyTxt + '</span></div>';
      }
      tiersEl.innerHTML = '<div class="v2-tiers__h">Mua càng nhiều, càng rẻ</div>'
        + '<div class="v2-tiers__row">'
        + card('1 sản phẩm', 'Giá gốc', false)
        + card(CFG.t1 + ' sản phẩm', '−' + CFG.o1 + '%', false)
        + (CFG.t2 ? card('Từ ' + CFG.t2 + ' sản phẩm', '−' + CFG.o2 + '%', true) : '')
        + '</div>'
        + (CFG.free ? '<div class="v2-tiers__ship"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg><span>Freeship đơn từ <b>' + money(CFG.free * 100) + '</b> · Trộn loại nào cũng được</span></div>' : '');
    }

    /* Ảnh */
    var gal = $('[data-v2-gal]', root);
    var track = gal && $('[data-gal-track]', gal);
    var slides = track ? $$('.v2-gal__slide', track) : [];
    var thumbs = gal ? $$('[data-gal-go]', gal) : [];
    var countEl = gal && $('[data-gal-count]', gal);
    var idx = gal ? +gal.dataset.start || 0 : 0;
    function setActive(i) {
      idx = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
      var th = thumbs[i];
      if (th && th.parentElement) {
        var p = th.parentElement;
        if (mqDesk.matches) p.scrollTo({ top: th.offsetTop - p.clientHeight / 2 + th.offsetHeight / 2, behavior: behavior });
        else p.scrollTo({ left: th.offsetLeft - p.clientWidth / 2 + th.offsetWidth / 2, behavior: behavior });
      }
    }
    function go(i, instant) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      setActive(i);
      if (!mqDesk.matches && track) track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : behavior });
    }
    if (track) {
      var st = 0;
      track.addEventListener('scroll', function () {
        if (mqDesk.matches) return;
        cancelAnimationFrame(st);
        st = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== idx) setActive(i);
        });
      }, { passive: true });
      if (idx) requestAnimationFrame(function () { go(idx, true); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(+t.dataset.galGo); });
      t.addEventListener('mouseenter', function () { if (mqDesk.matches) go(+t.dataset.galGo); });
    });
    $$('[data-gal-dir]', root).forEach(function (b) { b.addEventListener('click', function () { go(idx + +b.dataset.galDir); }); });

    /* Biến thể */
    function selectedOptions() {
      return $$('.v2-opt', form).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function update(v) {
      if (!v) return;
      current = v;
      idInput.value = v.id;
      var price = $('[data-price]', root), cmp = $('[data-compare]', root), off = $('[data-off]', root);
      price.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        cmp.hidden = false; cmp.textContent = money(v.compare_at_price);
        off.hidden = false; off.textContent = '−' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      } else { cmp.hidden = true; off.hidden = true; }
      $$('[data-mini-price]').forEach(function (e) { e.textContent = money(v.price); });
      if (pick) {
        $('[data-pk-price]', pick).textContent = money(v.price);
        var pc = $('[data-pk-cmp]', pick);
        var hasCmp = v.compare_at_price > v.price;
        pc.style.visibility = hasCmp ? '' : 'hidden'; /* giữ chỗ → bảng không nhảy */
        if (hasCmp) pc.textContent = money(v.compare_at_price);
        var sel = $('[data-pk-sel]', pick);
        if (sel && variants.length > 1) sel.textContent = 'Đã chọn: ' + v.title;
        var im = $('[data-pk-img]', pick);
        if (im && v.featured_image) im.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      }
      $$('.v2-opt', form).forEach(function (fs, k) {
        var lab = $('[data-opt-val]', fs);
        if (lab) lab.textContent = v.options[k];
      });
      var ok = v.available;
      $$('[data-add], [data-buy], [data-proxy]').forEach(function (b) { b.disabled = !ok; });
      $$('[data-add-label]').forEach(function (l) { l.textContent = ok ? 'Thêm vào giỏ' : 'Tạm hết hàng'; });
      if (v.featured_media) {
        var mi = mediaIds.indexOf(v.featured_media.id);
        if (mi > -1) go(mi);
      }
      var u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.toString());
      recalc();
    }
    form.addEventListener('change', function (e) {
      if (!e.target.closest('.v2-opt')) return;
      var opts = selectedOptions();
      var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === opts[k]; }); })[0];
      if (v) update(v);
      else {
        /* Không có tổ hợp này → chọn biến thể gần nhất có cùng lựa chọn vừa bấm */
        var k0 = +e.target.closest('.v2-opt').dataset.opt;
        v = variants.filter(function (x) { return x.options[k0] === opts[k0]; })[0];
        if (v) {
          $$('.v2-opt', form).forEach(function (fs, k) {
            $$('input', fs).forEach(function (inp) { inp.checked = inp.value === v.options[k]; });
          });
          update(v);
        }
      }
    });

    /* Số lượng */
    function qty() { var q = parseInt(qtyInput.value, 10); return q > 0 ? Math.min(q, 99) : 1; }
    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, Math.min(99, qty() + +b.dataset.qty)); recalc(); });
    });
    qtyInput.addEventListener('change', function () { qtyInput.value = qty(); recalc(); });
    qtyInput.addEventListener('input', recalc);

    /* Thêm vào giỏ */
    var busy = false;
    function setCount(n) {
      $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
    }
    function flash(text) {
      $$('[data-add-label]').forEach(function (l) { l.textContent = text; });
      setTimeout(function () {
        $$('[data-add-label]').forEach(function (l) { l.textContent = current.available ? 'Thêm vào giỏ' : 'Tạm hết hàng'; });
      }, 1800);
    }
    function addToCart() {
      if (busy || !current.available) return;
      busy = true;
      errEl.hidden = true;
      $$('[data-add], [data-proxy="add"]').forEach(function (b) { b.classList.add('is-busy'); });
      var item = { id: current.id, quantity: qty(), product_id: +root.dataset.productId };
      (window.V2Cart
        ? window.V2Cart.add([item], { open: false })
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
          .then(function (r) { if (!r.ok) throw new Error('Không thêm được vào giỏ'); return fetch('/cart.js'); })
          .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }))
        .then(function () { flash('Đã thêm vào giỏ ✓'); closePick(false); showToast(); qtyInput.value = 1; })
        .catch(function (e) { errEl.textContent = e.message; errEl.hidden = false; })
        .finally(function () {
          busy = false;
          $$('[data-add], [data-proxy="add"]').forEach(function (b) { b.classList.remove('is-busy'); });
        });
    }
    /* Mua ngay: thêm vào giỏ rồi sang thanh toán – gộp cả các món đã có trong giỏ (khuyến mãi tự áp dụng) */
    function buyNow() {
      if (!current.available || busy) return;
      busy = true;
      $$('[data-buy], [data-proxy="buy"]').forEach(function (b) { b.classList.add('is-busy'); });
      var item = { id: current.id, quantity: qty(), product_id: +root.dataset.productId };
      (window.V2Cart
        ? window.V2Cart.checkout([item])
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
          .then(function () { location.href = '/checkout'; }))
        .catch(function (e) {
          errEl.textContent = e.message; errEl.hidden = false; busy = false;
          $$('[data-buy], [data-proxy="buy"]').forEach(function (b) { b.classList.remove('is-busy'); });
        });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    /* Quay lại từ trang thanh toán bằng nút Back → mở khóa nút */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      busy = false;
      $$('.is-busy').forEach(function (b) { b.classList.remove('is-busy'); });
    });
    $('[data-buy]', form).addEventListener('click', buyNow);
    /* Nút "Mua ngay" ngoài bảng chọn (thanh ghim, thanh tab, nút cuối trang):
       - Giỏ ĐÃ CÓ sản phẩm này → sang thanh toán luôn (khách đã chọn rồi, không bắt chọn lại → không bị mua thừa)
       - Giỏ trống / chỉ có sản phẩm khác → mở bảng chọn
       Nút "Thêm vào giỏ" và "Chọn sản phẩm" luôn mở bảng chọn. */
    function quickBuy(btn) {
      if (busy) return;
      busy = true;
      btn.classList.add('is-busy');
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          cartNow = c;
          var pid = +root.dataset.productId;
          var has = (c.items || []).some(function (it) { return it.product_id === pid; });
          if (has) { location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; return; }
          busy = false; btn.classList.remove('is-busy'); openPick();
        })
        .catch(function () { busy = false; btn.classList.remove('is-busy'); openPick(); });
    }
    document.addEventListener('click', function (e) {
      var p = e.target.closest('[data-proxy], [data-pick], [data-jump="buy"]');
      if (!p || p.disabled) return;
      e.preventDefault();
      if (p.dataset.proxy === 'buy' || p.dataset.jump === 'buy') quickBuy(p);
      else openPick();
    });
  }

  /* ---------------- Tab dính + thanh mua nhỏ ---------------- */
  function initTabs() {
    var nav = $('[data-v2-tabs]');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var list = $('[data-v2-tablist]', nav);
    var mini = $('[data-v2-mini]', nav);
    if (nav.dataset.reviews) {
      var rv = $('.shopify-section[id$="__reviews"]');
      if (rv && !rv.hasAttribute('data-v2-anchor')) { rv.setAttribute('data-v2-anchor', nav.dataset.reviews); rv.id = rv.id || 'reviews'; }
    }
    var secs = $$('[data-v2-anchor]').filter(function (s) { return s.offsetParent !== null || s.getClientRects().length; });
    var wrap = nav.closest('.shopify-section') || nav;
    if (secs.length >= 2) nav.classList.remove('is-hidden');
    else wrap.style.display = 'none';
    var links = secs.map(function (sec) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'v2-ptab';
      b.textContent = sec.getAttribute('data-v2-anchor');
      b.addEventListener('click', function () { scrollToEl(sec); });
      list.appendChild(b);
      return b;
    });
    var cta = $('[id^="buy-cta-"]');
    var active = -1;
    function syncTop() {
      wrap.style.top = Math.round(headerBottom()) + 'px';
    }
    function onScroll() {
      syncTop();
      var line = nav.getBoundingClientRect().bottom + 48;
      var i = -1;
      secs.forEach(function (s, k) { if (s.getBoundingClientRect().top <= line) i = k; });
      if (i !== active) {
        active = i;
        links.forEach(function (l, k) { l.classList.toggle('is-on', k === i); });
        var a = links[i];
        if (a) list.scrollTo({ left: a.offsetLeft - 40, behavior: behavior });
      }
      if (mini && cta) {
        var show = cta.getBoundingClientRect().bottom < headerBottom() + nav.offsetHeight;
        mini.classList.toggle('is-on', show);
        mini.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', mini).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }
    }
    var tk = 0;
    window.addEventListener('scroll', function () {
      if (tk) return;
      tk = requestAnimationFrame(function () { tk = 0; onScroll(); });
    }, { passive: true });
    window.addEventListener('resize', onScroll);
    /* Menu ẩn/hiện → thanh tab trượt theo ngay */
    var hdr = $('.section-header');
    if (hdr && window.MutationObserver) new MutationObserver(syncTop).observe(hdr, { attributes: true, attributeFilter: ['class'] });
    onScroll();
  }

  /* ---------------- Video review ---------------- */
  function initVideos(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = $('[data-vtrack]', root);
    var cards = $$('.v2-vid', track);
    var current = null;

    function parse(url) {
      var m;
      if ((m = url.match(/(?:youtube\.com\/(?:shorts\/|watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/))) {
        return { yt: true, id: m[1], thumb: 'https://i.ytimg.com/vi/' + m[1] + '/oar2.jpg',
          embed: 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&playsinline=1&rel=0&modestbranding=1&enablejsapi=1&origin=' + encodeURIComponent(location.origin) };
      }
      if ((m = url.match(/tiktok\.com\/.*\/video\/(\d+)/))) return { embed: 'https://www.tiktok.com/player/v1/' + m[1] + '?autoplay=1&music_info=0&description=0&rel=0' };
      if ((m = url.match(/instagram\.com\/(?:reel|reels|p)\/([\w-]+)/))) return { embed: 'https://www.instagram.com/reel/' + m[1] + '/embed' };
      if (/facebook\.com|fb\.watch/.test(url)) return { embed: 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(url) + '&show_text=false&autoplay=true&width=560' };
      return { embed: url };
    }
    var PAUSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>';
    var PLAY = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4v16l13-8z"/></svg>';
    var CLOSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

    function ytCmd(card, func) {
      var f = $('iframe', card);
      if (f && f.contentWindow) f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
    }
    function setPaused(card, paused) {
      card.classList.toggle('is-paused', paused);
      var b = $('.v2-vid__ctl', card);
      if (b) { b.innerHTML = paused ? PLAY : PAUSE; b.setAttribute('aria-label', paused ? 'Phát tiếp' : 'Dừng video'); }
    }
    function pause(card) {
      if (!card || !card.classList.contains('is-playing')) return;
      var v = $('video', card);
      if (v) { v.pause(); setPaused(card, true); return; }
      if (card._info && card._info.yt) { ytCmd(card, 'pauseVideo'); setPaused(card, true); return; }
      stop(card);
    }
    function resume(card) {
      var v = $('video', card);
      if (v) { v.play(); setPaused(card, false); return; }
      if (card._info && card._info.yt) { ytCmd(card, 'playVideo'); setPaused(card, false); }
    }
    function stop(card) {
      if (!card) return;
      $$('iframe, video, .v2-vid__ctl, .v2-vid__x, .v2-vid__load', card).forEach(function (e) { e.remove(); });
      card.classList.remove('is-playing', 'is-paused', 'is-ready');
      card.setAttribute('tabindex', '0');
      if (current === card) current = null;
    }
    function play(card) {
      if (card.classList.contains('is-playing')) return;
      if (current) stop(current);
      current = card;
      card.classList.add('is-playing');
      card.removeAttribute('tabindex');
      var load = document.createElement('div');
      load.className = 'v2-vid__load';
      load.textContent = 'Đang tải video…';
      card.appendChild(load);
      var tpl = $('template', card), media;
      if (tpl) {
        card.appendChild(tpl.content.cloneNode(true));
        media = $('video', card);
        /* Đang tải (chưa chạy) thì chạm thêm KHÔNG tính là dừng – tránh phải bấm 2–3 lần trên điện thoại */
        media.addEventListener('playing', function () { load.remove(); card.classList.add('is-ready'); });
        media.addEventListener('waiting', function () { if (!card.contains(load)) { load.textContent = 'Đang tải video…'; card.appendChild(load); } });
        media.addEventListener('canplay', function () { if (card.classList.contains('is-ready')) load.remove(); });
        media.addEventListener('pause', function () { if (card.classList.contains('is-ready')) setPaused(card, true); });
        media.addEventListener('play', function () { setPaused(card, false); });
        media.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!card.classList.contains('is-ready')) { if (media.paused) media.play().catch(function () {}); return; }
          media.paused ? resume(card) : pause(card);
        });
        var pr = media.play && media.play();
        if (pr && pr.catch) pr.catch(function () { load.textContent = 'Chạm để phát'; setPaused(card, true); card.classList.add('is-ready'); });
      } else if (card._info) {
        media = document.createElement('iframe');
        media.src = card._info.embed;
        media.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        media.allowFullscreen = true;
        media.title = 'Video review';
        media.addEventListener('load', function () {
          setTimeout(function () { load.remove(); }, 300);
          /* YouTube: nghe trạng thái thật để nút Dừng/Phát luôn đúng */
          if (card._info.yt) media.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1 }), '*');
        });
        card.appendChild(media);
      }
      /* Nút Dừng/Phát + Đóng riêng: luôn bấm được trên điện thoại */
      var ctl = document.createElement('button');
      ctl.type = 'button';
      ctl.className = 'v2-vid__ctl';
      ctl.innerHTML = PAUSE;
      ctl.setAttribute('aria-label', 'Dừng video');
      ctl.addEventListener('click', function (e) {
        e.stopPropagation();
        card.classList.contains('is-paused') ? resume(card) : pause(card);
      });
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'v2-vid__x';
      x.innerHTML = CLOSE;
      x.setAttribute('aria-label', 'Đóng video');
      x.addEventListener('click', function (e) { e.stopPropagation(); stop(card); });
      if (tpl || (card._info && card._info.yt)) card.appendChild(ctl);
      card.appendChild(x);
    }

    cards.forEach(function (card) {
      var url = card.getAttribute('data-url');
      if (url) {
        card._info = parse(url);
        if (card._info.thumb) {
          var img = $('.v2-vid__poster', card);
          if (!img) { img = document.createElement('img'); img.className = 'v2-vid__poster'; img.alt = ''; img.loading = 'lazy'; card.insertBefore(img, card.firstChild); }
          img.removeAttribute('srcset'); img.removeAttribute('sizes');
          /* YouTube Shorts: ảnh bìa DỌC nét (oar2 1080×1920) → thiếu thì lùi dần về ảnh ngang */
          if (card._info.yt) {
            var tries = ['oardefault', 'hq720', 'hqdefault'], id = card._info.id;
            img.onerror = function () { var n = tries.shift(); if (n) img.src = 'https://i.ytimg.com/vi/' + id + '/' + n + '.jpg'; else img.onerror = null; };
          }
          img.src = card._info.thumb;
        }
        /* Tiêu đề lấy từ tên video trên YouTube (bỏ qua nếu tên chỉ là tên file, vd "DSV01.2.mp4") */
        if (card._info.yt && !$('.v2-vid__title', card)) {
          fetch('https://www.youtube.com/oembed?format=json&url=' + encodeURIComponent('https://www.youtube.com/shorts/' + card._info.id))
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (d) {
              var t = d && d.title ? String(d.title).trim() : '';
              if (!t || /\.(mp4|mov|m4v|avi|mkv|webm)$/i.test(t)) return;
              var sp = document.createElement('span');
              sp.className = 'v2-vid__title';
              sp.textContent = t;
              card.appendChild(sp);
              card.setAttribute('aria-label', 'Phát video: ' + t);
            })
            .catch(function () {});
        }
      }
      card.addEventListener('click', function () {
        if (card.classList.contains('is-playing')) return;
        if (!mqDesk.matches && !card.classList.contains('is-center')) {
          track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: behavior });
        }
        play(card);
      });
      card.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === card) { e.preventDefault(); play(card); }
      });
    });

    window.addEventListener('message', function (e) {
      if (!current || !current._info || !current._info.yt) return;
      var f = $('iframe', current);
      if (!f || e.source !== f.contentWindow) return;
      var d;
      try { d = JSON.parse(e.data); } catch (_) { return; }
      var st = d && d.info && d.info.playerState;
      if (st === undefined) return;
      if (st === 1 || st === 3) setPaused(current, false);
      else if (st === 2 || st === 0 || st === -1 || st === 5) setPaused(current, true);
    });

    /* Tự dừng khi cuộn khỏi màn hình */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (!en.isIntersecting && en.target === current) pause(current); });
      }, { threshold: 0.25 });
      cards.forEach(function (c) { io.observe(c); });
    }

    /* Chấm viên thuốc + mũi tên */
    function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    var dotsWraps = $$('[data-vdots]', root);
    function pages() { var o = track.scrollWidth - track.clientWidth; return o > 4 ? Math.ceil(o / step()) + 1 : 1; }
    function build() {
      var n = pages();
      root.classList.toggle('is-fit', n < 2);
      dotsWraps.forEach(function (w) {
        w.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Tới video ' + (i + 1));
          (function (k) { b.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: behavior }); }); })(i);
          w.appendChild(b);
        }
      });
      upd();
    }
    function upd() {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var n = dotsWraps[0] ? dotsWraps[0].children.length : 0;
      var i = atEnd ? n - 1 : Math.round(track.scrollLeft / step());
      dotsWraps.forEach(function (w) { Array.prototype.forEach.call(w.children, function (d, k) { d.classList.toggle('is-on', k === i); }); });
    }
    /* Điện thoại: video ở giữa to hơn (nổi lên), video hai bên thu nhỏ; vuốt đi thì video đang phát tự dừng */
    var centerCard = null;
    function markCenter() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = null, bd = 1e9;
      cards.forEach(function (c) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
        if (d < bd) { bd = d; best = c; }
      });
      if (best === centerCard) return;
      cards.forEach(function (c) { c.classList.toggle('is-center', c === best); });
      centerCard = best;
      if (current && current !== best && !mqDesk.matches) pause(current);
    }
    var sc = 0;
    track.addEventListener('scroll', function () {
      if (sc) return;
      sc = setTimeout(function () { sc = 0; upd(); markCenter(); }, 60);
    }, { passive: true });
    markCenter();
    $$('[data-vdir]', root).forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: step() * +b.dataset.vdir, behavior: behavior }); });
    });
    window.addEventListener('resize', build);
    build();
  }

  /* ---------------- Chi tiết: dàn nội dung mô tả thành thẻ ---------------- */
  function onlyImg(el) {
    return el && el.tagName === 'P' && el.querySelector('img') && el.textContent.trim() === '';
  }
  function initRich(rich) {
    if (!rich || rich.dataset.ready) return;
    rich.dataset.ready = '1';
    var n = 0;
    $$(':scope > ul, :scope > ol', rich).forEach(function (list) {
      var items = $$(':scope > li', list);
      if (!items.length) return;
      if (list.tagName === 'OL') { list.classList.add('is-steps'); return; }
      /* Danh sách ngay dưới tiêu đề "Ứng dụng…" → nhãn */
      var prev = list.previousElementSibling;
      if (prev && /^H[2-4]$/.test(prev.tagName) && /ứng dụng/i.test(prev.textContent)) {
        list.classList.add('is-chips');
        items.forEach(function (li) { li.textContent = li.textContent.trim(); });
        return;
      }
      var strong = items.every(function (li) { var s = li.querySelector('strong, b'); return s && li.textContent.trim().indexOf(s.textContent.trim()) < 3; });
      /* Ý đậm + ảnh ngay sau → khối tính năng 01, 02… */
      var next = list.nextElementSibling;
      if (strong && items.length === 1 && onlyImg(next)) {
        n++;
        var li = items[0], s = li.querySelector('strong, b');
        var title = s.textContent.trim().replace(/:$/, '');
        s.remove();
        var d = li.textContent.trim().replace(/^[:\-–\s]+/, '');
        var feat = document.createElement('div');
        feat.className = 'v2-feat';
        feat.setAttribute('data-reveal', '');
        var img = next.querySelector('img');
        img.removeAttribute('width'); img.removeAttribute('height'); img.loading = 'lazy';
        var media = document.createElement('div');
        media.className = 'v2-feat__media';
        media.appendChild(img);
        var body = document.createElement('div');
        body.className = 'v2-feat__b';
        body.innerHTML = '<div class="v2-feat__n">' + (n < 10 ? '0' + n : n) + '</div><h3 class="v2-feat__t"></h3><p class="v2-feat__d"></p>';
        body.querySelector('.v2-feat__t').textContent = title;
        body.querySelector('.v2-feat__d').textContent = d;
        feat.appendChild(media); feat.appendChild(body);
        list.replaceWith(feat);
        next.remove();
        return;
      }
      if (strong) {
        list.classList.add('is-cards', items.length <= 3 ? 'is-c3' : 'is-c2');
        items.forEach(function (li) {
          var s = li.querySelector('strong, b');
          var t = s.textContent.trim().replace(/:$/, '');
          s.remove();
          var d = li.textContent.trim().replace(/^[:\-–\s]+/, '');
          li.innerHTML = '<div class="v2-rcard__t"></div><div class="v2-rcard__d"></div>';
          li.firstChild.textContent = t;
          li.lastChild.textContent = d;
          if (!d) li.lastChild.remove();
        });
        return;
      }
      var short = items.every(function (li) { return li.textContent.trim().length <= 60; });
      list.classList.add(short ? 'is-chips' : 'is-list');
    });
    $$(':scope > p', rich).forEach(function (p) {
      if (onlyImg(p)) p.classList.add('is-img');
      else if (!p.textContent.trim()) p.remove();
    });
    $$(':scope > h2, :scope > h3, :scope > h4', rich).forEach(function (h) { h.setAttribute('data-reveal', ''); });
    window.dispatchEvent(new Event('scroll'));
  }

  /* ---------------- Hỏi đáp ---------------- */
  function initFaq() {
    $$('.v2-acc__q').forEach(function (q) {
      if (q.dataset.ready) return;
      q.dataset.ready = '1';
      q.addEventListener('click', function () {
        var acc = q.closest('.v2-acc');
        var open = !acc.classList.contains('is-open');
        acc.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------- Sản phẩm liên quan ---------------- */
  /* ---------------- Dòng sao gọn dưới tên sản phẩm (kiểu Shopee) ---------------- */
  function initRvLine() {
    var box = $('[data-v2-rv]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';
    var count = parseInt(box.dataset.count, 10) || 0;
    function build(avg) {
      if (box.querySelector('.v2-rv')) return true;
      var pct = Math.max(0, Math.min(100, avg / 5 * 100));
      var stars = '★★★★★';
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'v2-rv';
      a.setAttribute('aria-label', 'Đánh giá ' + avg.toFixed(1) + ' trên 5' + (count ? ', ' + count + ' đánh giá' : '') + '. Xem đánh giá');
      a.innerHTML = '<span class="v2-rv__stars" aria-hidden="true"><span class="v2-rv__bg">' + stars + '</span><span class="v2-rv__fg" style="width:' + pct + '%">' + stars + '</span></span>'
        + '<b>' + avg.toFixed(1) + '</b>' + (count ? '<span class="v2-rv__sep">·</span><span class="v2-rv__n">' + count + ' đánh giá</span>' : '');
      a.addEventListener('click', function () {
        var sec = $('.shopify-section[id$="__reviews"]');
        if (sec) scrollToEl(sec);
      });
      box.appendChild(a);
      box.classList.add('is-compact');
      return true;
    }
    function read() {
      var lab = $('[aria-label*="out of 5"]', box);
      var m = lab && lab.getAttribute('aria-label').match(/([\d.,]+)\s*out of 5/);
      if (!m) { var t = box.textContent.match(/\((\d+[.,]\d+)\)/); if (t) m = t; }
      if (!m) return false;
      var avg = parseFloat(String(m[1]).replace(',', '.'));
      if (!(avg > 0)) return false;
      return build(avg);
    }
    if (read()) return;
    /* App tải sau → chờ nội dung xuất hiện (tối đa ~10 giây) */
    var mo = new MutationObserver(function () { if (read()) mo.disconnect(); });
    mo.observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
    setTimeout(function () { mo.disconnect(); }, 10000);
  }

  function initRelated() {
    $$('[data-v2-rel]').forEach(function (sec) {
      if (sec.dataset.ready || sec.children.length) return;
      sec.dataset.ready = '1';
      fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-v2-rel]');
        if (fresh && fresh.children.length) { sec.innerHTML = fresh.innerHTML; window.dispatchEvent(new Event('scroll')); }
      }).catch(function () {});
    });
  }

  function init() {
    initBuy($('[data-v2-pd]'));
    $$('[data-v2-rich]').forEach(initRich);
    $$('[data-v2-vids]').forEach(initVideos);
    initFaq();
    initRvLine();
    initTabs();
    initRelated();
    document.addEventListener('click', function (e) {
      var j = e.target.closest('[data-jump]');
      if (!j) return;
      if (j.dataset.jump === 'videos') scrollToEl(document.getElementById('videos'));
      else if (j.dataset.jump === 'buy' && !$('[data-v2-pick]')) {
        var b = $('.v2-buy');
        if (b) window.scrollTo({ top: b.getBoundingClientRect().top + window.scrollY - headerBottom() - 12, behavior: behavior });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
